import { render, staticRenderFns } from "./Help_en-top.vue?vue&type=template&id=6427cded&"
import script from "./Help_en-top.vue?vue&type=script&lang=js&"
export * from "./Help_en-top.vue?vue&type=script&lang=js&"
import style0 from "./Help_en-top.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports